<div *ngFor="let alert of alerts" class="{{cssClass(alert)}}">
    <a class="close" (click)="removeAlert(alert)">&times;</a>
    <span [innerHTML]="alert.message"></span>
    <br>
    <button class="btn btn-danger" *ngIf="route" (click)="routeTo(route)">Back</button>
</div>

<style>
    .close:hover {
        cursor:pointer
    }
</style>